export default __webpack_public_path__ + "static/media/hall_of_fame_header_two.a44c3d87.png";